(() => {
const dialog = document.querySelector('.product-zoom');
if (!dialog || typeof dialog.showModal !== 'function') return;
const image = dialog.querySelector('.product-zoom-image');
const viewport = dialog.querySelector('.product-zoom-viewport');
const toggle = dialog.querySelector('.product-zoom-toggle');
let opener;
let previousOverflow;
const reset = () => {
dialog.classList.remove('is-enlarged');
toggle.setAttribute('aria-pressed', 'false');
toggle.textContent = toggle.dataset.labelIn;
viewport.scrollTop = 0;
viewport.scrollLeft = 0;
};
document.querySelectorAll('.product-gallery').forEach(gallery => {
const main = gallery.querySelector('.main-product-image');
const open = gallery.querySelector('.product-photo-open');
if (!main || !open) return;
gallery.querySelectorAll('[data-product-image]').forEach(button => {
button.addEventListener('click', () => {
main.removeAttribute('srcset');
main.src = button.dataset.productImage;
main.dataset.zoomSource = button.dataset.productZoom || button.dataset.productImage;
main.alt = button.querySelector('img').alt;
gallery.querySelectorAll('[data-product-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
});
});
open.addEventListener('click', () => {
if (dialog.open) return;
opener = open;
image.src = main.dataset.zoomSource || main.currentSrc || main.src;
image.alt = main.alt;
reset();
previousOverflow = document.body.style.overflow;
document.body.style.overflow = 'hidden';
dialog.showModal();
});
});
toggle.addEventListener('click', () => {
const enlarged = dialog.classList.toggle('is-enlarged');
toggle.setAttribute('aria-pressed', String(enlarged));
toggle.textContent = enlarged ? toggle.dataset.labelOut : toggle.dataset.labelIn;
viewport.scrollTop = enlarged ? (viewport.scrollHeight - viewport.clientHeight) / 2 : 0;
viewport.scrollLeft = enlarged ? (viewport.scrollWidth - viewport.clientWidth) / 2 : 0;
});
dialog.querySelector('.product-zoom-close').addEventListener('click', () => dialog.close());
dialog.addEventListener('click', event => {
if (event.target !== dialog) return;
const bounds = dialog.getBoundingClientRect();
if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
});
dialog.addEventListener('close', () => {
document.body.style.overflow = previousOverflow;
reset();
if (opener) opener.focus();
});
})();